import React from "react";
import * as d3 from "d3";

const Label = {
  fill: "#fff",
  textAnchor: "end",
};
const style = {
  fill: "#485FFF",
};
const Whiteclr = {
  fill: "#fff",
};
const fontSize = {
  fontSize: "12px",
  fill: "#fff",
};

// CONCENTRIC CIRCLE
const CircleArcs = (props) => {
  let { NewData, maxR } = props;
  if (!NewData) return;

  let end1 = NewData[1].value;
  let end2 = NewData[0].value;

  let end3 = 0;
  if (NewData.length === 3) {
    end3 = NewData[2].value;
  }
  let mid = NewData.map((e) => e.value).reduce((a, b) => a + b, 0) / 2;
  // outer
  var arc1 = d3.svg
    .arc()
    .innerRadius(78)
    .outerRadius(85)
    .startAngle(0)
    .endAngle(end1 / (mid / 3.14));

  // middle
  var arc2 = d3.svg
    .arc()
    .innerRadius(53)
    .outerRadius(60)
    .startAngle(0)
    .endAngle(end2 / (mid / 3.14));

  // inner most
  let arc3 = d3.svg
    .arc()
    .innerRadius(28)
    .outerRadius(35)
    .startAngle(0)
    .endAngle(end3 / (mid / 3.14));

  return (
    <g>
      <circle cx={0} cy={0} r={maxR + 10} style={style} />
      <g>
        <path d={arc1()} style={Whiteclr} />
        <text x={-82} dy={-78} style={Whiteclr}>
          {NewData[1].name}
        </text>
        <text x={69} dy={-50} style={fontSize}>
          {`${(NewData[1].growth / 1000).toFixed(1) * 1}k`}
        </text>
      </g>
      <g>
        <path d={arc2()} style={Whiteclr} />
        <text x={-82} dy={-53} style={Whiteclr}>
          {NewData[0].name}
        </text>
        <text x={-25} dy={48} style={fontSize}>
          {`${(NewData[0].growth / 1000).toFixed(1) * 1}k`}{" "}
        </text>
      </g>
      {props.NewData.length === 3 ? (
        <g>
          <path d={arc3()} style={Whiteclr} />
          <text x={-82} dy={-28} style={Whiteclr}>
            {NewData[2].name}
          </text>
          <text x={-15} dy={5} style={fontSize}>
            {`${(NewData[2].growth / 1000).toFixed(1) * 1}k`}{" "}
          </text>
        </g>
      ) : null}
      <g>
        <g id="arc3"></g>
      </g>
    </g>
  );
};
export default CircleArcs;



// WEBPACK FOOTER //
// ./src/components/d3Components/circlearc/CircleArcs.js